import React from 'react';
import AModal from 'antd-mobile/lib/modal';



export default class Modal extends AModal {}